import React from 'react';
import Typography from '@mui/material/Typography';
import { AppCard, AppPageHeader } from '../../components';
import { DatasetsTable } from '../../components/Admin';

export default function DatasetsPage() {
	return (
		<>
			<AppPageHeader>
				<Typography variant="h6">Datasets</Typography>
				<Typography variant="body2" color="text.secondary">
					View all datasets and grant access to users
				</Typography>
			</AppPageHeader>
			<AppCard>
				<DatasetsTable />
			</AppCard>
		</>
	);
}
